import { SelectItem } from "@/components/ui/select.tsx";
import { DEFAULT_TIME_FRAME, TIME_FRAMES, type TimeFrame } from "@domains/engagement/shared/timeFrame.ts";
import { EngagementInfoTooltip } from "@domains/engagement/client/components/EngagementInfoTooltip.tsx";
import { FilterChipSelect } from "@packages/core-client/collection/FilterChipSelect.tsx";
import { useI18nextInstance } from "@squide/i18next";
import { useCallback } from "react";
import type { Key } from "react-aria-components";
import { useTranslation } from "react-i18next";
import { i18NextInstanceKey } from "../i18n/i18next.ts";

export interface EngagementPeriodToolbarProps {
    timeFrame: TimeFrame;
    onTimeFrameChange: (timeFrame: TimeFrame) => void;
    disabledReason?: string;
}

export function EngagementPeriodToolbar({ timeFrame, onTimeFrameChange, disabledReason }: EngagementPeriodToolbarProps) {
    const i18nextInstance = useI18nextInstance(i18NextInstanceKey);
    const { t } = useTranslation("EngagementPeriodToolbar", { i18n: i18nextInstance });

    const handleChange = useCallback(
        (key: Key) => {
            const next = TIME_FRAMES.find(value => value === key) ?? DEFAULT_TIME_FRAME;
            onTimeFrameChange(next);
        },
        [onTimeFrameChange]
    );

    return (
        <div className="flex items-center gap-1">
            <FilterChipSelect ariaLabel={t("timeFrame.ariaLabel")} clearAriaLabel={t("timeFrame.clearAriaLabel")} selectedKey={timeFrame} defaultKey={DEFAULT_TIME_FRAME} onSelectionChange={handleChange} isDisabled={!!disabledReason}>
                {TIME_FRAMES.map(value => (
                    <SelectItem key={value} id={value} textValue={t(`timeFrame.${value}`)}>
                        {t(`timeFrame.${value}`)}
                    </SelectItem>
                ))}
            </FilterChipSelect>
            {disabledReason && <EngagementInfoTooltip label={t("disabledInfoLabel")} description={disabledReason} />}
        </div>
    );
}
